/* eslint-disable */
import * as DateHelper from '../helpers/date'
import _ from 'lodash'


// export const doneToday = (routine) => {
//   return _.includes(_.map(routine.datesDone, formatyyymmdd), formatyyymmdd(midnight()))
// }

export default (story) => new StoryEntity(story)

class StoryEntity {
  constructor(story) {
    // console.log('storyEntity()', story.id)
    this.story = story
  }

  freeWrite () {
    return this.story.storyType === 'freeWrite' || this.story.filter == 'free write'
  }

  discoveryQuestion () {
    return this.story.storyType === 'discoveryQuestion' || this.story.filter == 'get inspired'
  }

  moodTracker () {
    return this.story.storyType === 'moodTracker'
  }

  lifeBalance () {
    return this.story.storyType === 'lifeBalance'
  }

  oldJourneyItem () {
    return !this.story.storyType
  }

  sentiment () {
    return this.freeWrite() || this.discoveryQuestion() || this.oldJourneyItem()
  }

  moodText () {
    if (this.story.mood <= 0) {
      return 'awful'
    } else if (this.story.mood < 2) {
      return 'bad'
    } else if (this.story.mood < 4) {
      return 'down'
    } else if (this.story.mood < 6) {
      return 'okay'
    } else if (this.story.mood < 8) {
      return 'good'
     } else if (this.story.mood < 10) {
      return 'great'
    } else {
      return 'awesome'
    }
  }
}
